import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const { Form } = Common;

const SubaccountFormCustomFields = ({
  errors,
  handleValueChange,
  handleRemoveCustomField,
  handleAddCustomField,
  isSubmitted,
  t,
  values,
}) => {
  let { customFields = [] } = values;
  let visibles = customFields.filter((c) => !c.deleted);

  return (
    <Form.Section title={t('subaccounts.form.customFields')}>
      <div className="row align-items-center">
        <div className="col-12">
          <table className="table table-striped table-hover table-condensed">
            <thead>
              <tr>
                <th className="align-middle" width="40%">
                  {t('subaccounts.fields.customFields.key')}
                </th>
                <th className="align-middle" width="40%">
                  {t('subaccounts.fields.customFields.label')}
                </th>
                <th className="text-center align-middle" width="20%">
                  {t('common.actions')}
                </th>
              </tr>
            </thead>
            <tbody>
              {visibles.length === 0 && <Common.EmptyTable colSpan={3} />}
              {customFields.map((customField, index) =>
                customField.deleted ? null : (
                  <tr key={index}>
                    <td className="align-middle">
                      <Form.FieldInput
                        error={
                          (isSubmitted &&
                            errors[`customFields[${index}]`] &&
                            errors[`customFields[${index}]`].key) ||
                          {}
                        }
                        name={`customFields[${index}].key`}
                        placeholder={t('subaccounts.fields.customFields.key')}
                        handleChange={handleValueChange}
                        value={customField.key}
                      />
                    </td>
                    <td className="align-middle">
                      <Form.FieldInput
                        error={
                          (isSubmitted &&
                            errors[`customFields[${index}]`] &&
                            errors[`customFields[${index}]`].label) ||
                          {}
                        }
                        name={`customFields[${index}].label`}
                        placeholder={t('subaccounts.fields.customFields.label')}
                        handleChange={handleValueChange}
                        value={customField.label}
                      />
                    </td>
                    <td className="text-center">
                      <a
                        href={'#remove-customfield'}
                        className="btn btn-sm btn-outline-danger"
                        onClick={(e) => {
                          e.preventDefault();
                          handleRemoveCustomField(index);
                        }}
                      >
                        {t('actions.delete')}
                      </a>
                    </td>
                  </tr>
                )
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="2" />
                <td className="text-center">
                  <a
                    href={'#add-customfield'}
                    className="btn btn-sm btn-outline-success"
                    onClick={(e) => {
                      e.preventDefault();
                      handleAddCustomField();
                    }}
                  >
                    {t('actions.addOther')}
                  </a>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </Form.Section>
  );
};

export default translate()(SubaccountFormCustomFields);



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/components/form/sections/SubaccountFormCustomFields.js